import { render, staticRenderFns } from "./BrandDetail.vue?vue&type=template&id=6537df2e"
import script from "./BrandDetail.vue?vue&type=script&lang=js"
export * from "./BrandDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports